import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const wellbeingData = [
    {
        id: 1,
        title: "Dedicated Team",
        description: "A developer works exclusively for your project, fully aligned with your processes and timelines.",
        image: "/assets/transforming/img9.png"
    },
    {
        id: 2,
        title: "Staff Augmentation",
        description: "Your hard work never goes unnoticed at Mobikode. We celebrate your achievements and reward outstanding contributions with performance-based bonuses that recognize the value you bring to our team.",
        image: "/assets/transforming/img9.png"
    },
    {
        id: 3,
        title: "Project Based",
        description: "We believe success is better when shared. Our Share Purchase Plan gives you the opportunity to invest in the company at a discounted rate and be part of the journey as we grow together.",
        image: "/assets/transforming/img9.png"
    },

];

const EngagementModal = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-[#FFFFFF] font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                >
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight mb-[24px] md:mb-[60px]">
                        Engagement Models
                    </h2>
                </motion.div>

                <div className="flex flex-col lg:flex-row gap-[32px] md:gap-[50px] lg:gap-[100px]">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        variants={fadeUpVariant}
                        className="w-full lg:w-full max-w-[639px] flex flex-col"
                    >
                        {wellbeingData.map((item, index) => (
                            <div key={item.id} className="flex flex-col">
                                <div
                                    onClick={() => setActiveIndex(activeIndex === index && window.innerWidth < 1024 ? -1 : index)}
                                    className={`group cursor-pointer py-[16px] md:py-[20px] flex justify-between items-center border-b-[2px] transition-all duration-300 ${activeIndex === index
                                        ? 'border-[#F97316]'
                                        : 'border-[#E4E8F5] hover:border-[#01386A]'
                                        }`}
                                >
                                    <h3
                                        className={`text-[16px] md:text-[20px] pr-4 transition-colors duration-300 ${activeIndex === index
                                            ? 'text-[#01386A] font-[600]'
                                            : 'text-[#0000008C] font-[600] group-hover:text-[#01386A]'
                                            }`}
                                    >
                                        {item.title}
                                    </h3>

                                    <span
                                        className={`text-[#F97316] font-bold text-[18px] transition-all duration-300 ease-in-out shrink-0 ${activeIndex === index
                                            ? 'opacity-100 translate-x-0 rotate-90 lg:rotate-0'
                                            : 'opacity-0 lg:opacity-100 -translate-x-4 lg:translate-x-0 text-[#0000008C] group-hover:text-[#01386A]'
                                            }`}
                                    >
                                        &gt;
                                    </span>
                                </div>

                                <div className={`block lg:hidden overflow-hidden transition-[max-height] duration-300 ease-in-out ${activeIndex === index ? 'max-h-[1000px]' : 'max-h-0'}`}>
                                    <div className="py-5 border-b border-[#E4E8F5]">
                                        <p className="text-[#49577A] text-[14px] sm:text-[16px] font-graphik font-[500] leading-[1.6] mb-4">
                                            {item.description}
                                        </p>
                                        <div className="w-full overflow-hidden rounded-sm shadow-sm max-w-[550px]">
                                            <img
                                                src={item.image}
                                                alt={item.title}
                                                className="w-full h-auto object-cover"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </motion.div>

                    <div className="hidden lg:flex w-full lg:w-full ml-auto max-w-[461px] flex-col">
                        <AnimatePresence mode="wait">
                            {activeIndex !== -1 && (
                                <motion.div
                                    key={activeIndex}
                                    initial={{ opacity: 0, y: 15 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -15 }}
                                    transition={{ duration: 0.4, ease: "easeOut" }}
                                    className="flex flex-col h-full"
                                    AminatePresence>
                                    <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.6] max-w-[450px] mb-[40px]">
                                        {wellbeingData[activeIndex]?.description}
                                    </p>
                                    <div className="w-full overflow-hidden mt-auto rounded-sm group cursor-pointer shadow-sm">
                                        <img
                                            src={wellbeingData[activeIndex]?.image}
                                            alt={wellbeingData[activeIndex]?.title}
                                            className="w-full max-w-full h-[217px] object-cover transition-transform duration-700 ease-in-out group-hover:scale-105"
                                        />
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default EngagementModal;